module.exports = __webpack_public_path__ + "img/logo.9510bc77.svg";